"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const amex = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 40 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-amex` : '') + (description ? ` desc-amex` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-amex"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-amex"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M35.8225 21.376L34.1365 19.52L32.3857 21.376H28.9488H21.5563V12.736H18.1195L22.3993 3.072H26.5495L28.041 6.4V3.072H33.2287L34.1365 5.568L35.0444 3.072H39V1.6C39 0.704 38.2867 0 37.3788 0H2.62116C1.71331 0 1 0.704 1 1.6V22.4C1 23.296 1.71331 24 2.62116 24H37.3788C38.2867 24 39 23.296 39 22.4V21.376H35.8225Z",
    fill: "#0071CE"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M36.2765 20.352H39L35.4335 16.576L39 12.864H36.3413L34.0717 15.296L31.8669 12.864H29.1434L32.7748 16.64L29.1434 20.352H31.8021L34.0717 17.92L36.2765 20.352Z",
    fill: "#0071CE"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M24.7987 18.624V17.472H29.0785V15.744H24.7987V14.592H29.1434V12.864H22.7236V20.352H29.1434V18.624H24.7987Z",
    fill: "#0071CE"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M36.9898 11.776H38.9352V4.224L35.8226 4.288L34.1365 8.96L32.3857 4.288H29.1434V11.776H31.2185V6.528L33.1638 11.776H34.9795L36.9898 6.528V11.776Z",
    fill: "#0071CE"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M25.8362 4.28799H23.1775L19.8055 11.776H22.0751L22.7236 10.304H26.2253L26.8737 11.776H29.2082L25.8362 4.28799ZM23.4369 8.57599L24.4744 6.14399L25.512 8.57599H23.4369Z",
    fill: "#0071CE"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M37 16L39 18V14L37 16Z",
    fill: "#0071CE"
  }));
};
var _default = exports.default = amex;